import * as React from 'react'
import { ListFavoriteToolsQueryRootKey } from '../../../gen/service/creativefabrica/studiomediamatrix/v1'
import type { ListFavoriteToolsResponse } from '@repo/rpc-types-creativefabrica-studiomediamatrix-v1/service'
import { ListFavoriteToolsResponse_FavoritedToolSchema } from '@repo/rpc-types-creativefabrica-studiomediamatrix-v1/service'
import type { ToolType } from '@repo/rpc-types-creativefabrica-studiomediamatrix-v1'
import { useQueryClient } from '@tanstack/react-query'
import { create } from '@bufbuild/protobuf'

export function useUpdateFavoritesInCache() {
  const queryClient = useQueryClient()

  const addFavorite = React.useCallback(
    (tool: ToolType) => {
      queryClient.setQueriesData<ListFavoriteToolsResponse>(
        { queryKey: [ListFavoriteToolsQueryRootKey], exact: false },
        old => {
          if (!old) {
            return old
          }

          const favorites = old.favorites ?? []
          if (favorites.some(f => f.tool === tool)) {
            return old
          }

          return {
            ...old,
            favorites: [
              ...favorites,
              create(ListFavoriteToolsResponse_FavoritedToolSchema, { tool }),
            ],
          }
        },
      )
    },
    [queryClient],
  )

  const removeFavorite = React.useCallback(
    (tool: ToolType) => {
      queryClient.setQueriesData<ListFavoriteToolsResponse>(
        { queryKey: [ListFavoriteToolsQueryRootKey], exact: false },
        old => {
          if (!old) {
            return old
          }

          return {
            ...old,
            favorites: old.favorites?.filter(f => f.tool !== tool) ?? [],
          }
        },
      )
    },
    [queryClient],
  )

  return { addFavorite, removeFavorite }
}
